function getModalityUnit(modality, isPreScaled, isSuvScaled) {
    if (modality === 'CT') {
        return 'HU';
    }
    else if (modality === 'PT' &&
        isPreScaled === true &&
        isSuvScaled === true) {
        return 'SUV';
    }
    else {
        return '';
    }
}
export { getModalityUnit };
//# sourceMappingURL=getModalityUnit.js.map